import {Text as TroikaText} from "troika-three-text";
import {setObjectLayer} from "../../utils/layerUtils";
import {render} from "../../sceneManager";

export class Text {
    constructor(text, fontSize, anchorX, anchorY, position, rotation, layer = null, color = 0x000000, autoSync = true) {
        this.textObject = new TroikaText();
        this.textObject.text = text;
        this.textObject.fontSize = fontSize;
        this.textObject.rotation.x = rotation.x;
        this.textObject.rotation.y = rotation.y;
        this.textObject.rotation.z = rotation.z;
        this.textObject.anchorX = anchorX;
        this.textObject.anchorY = anchorY;
        this.textObject.position.x = position.x;
        this.textObject.position.y = position.y;
        this.textObject.position.z = position.z;
        this.textObject.color = color;
        if (layer !== null) {
            setObjectLayer(this.textObject, layer);
        }

        if (autoSync) {
            this.sync();
        }

        return this.textObject;
    }

    sync() {
        this.textObject.sync(() => {
            render();
        });
    }
}
